import SubscriptionPlan from './SubscriptionPlan';
import SubscriptionDetails from './SubscriptionDetails';
import { MembershipOrder, ParsedMembership } from '@/types/membership';
import { formatDate } from '@/utilities/formatDate';
import Image from 'next/image';
import Link from 'next/link';
import { CustomerInfo } from '@/types/user';
import { Order } from '@/types/order';

const InvoiceCard = ({ invoice }: { invoice: MembershipOrder }) => {
  const [legacyOrderId, key] = invoice.id.split('/').pop()?.split('?') || [
    '',
    ''
  ];
  return (
    <div className="hidden lg:grid grid-cols-5 gap-2 mt-6">
      <p className="font-normal text-lg">{formatDate(invoice.processedAt)}</p>
      <p className="font-normal text-lg">{invoice.orderNumber}</p>
      <p className="font-normal text-lg">
        {invoice.lineItems.nodes[0].title}
      </p>
      <p className="font-normal text-lg">
        ${invoice.currentTotalPrice?.amount}
      </p>
      <div className="flex ml-auto items-center">
        <div className="mr-6 cursor-pointer">
          <Link
            href={`/account/orders/${legacyOrderId}?${key}&isMembership=true`}
            passHref
          >
            <Image src="/icons/view.svg" alt="view" width={18} height={22} />
          </Link>
        </div>
      </div>
    </div>
  );
};

const MembershipTab = ({
  membership,
  orders,
  customerInfo
}: {
  membership?: ParsedMembership;
  orders: Order[];
  customerInfo: CustomerInfo;
}) => {
  const membershipOrders: MembershipOrder[] = orders
    .filter((order) => order.shippingAddress === null);

  return (
    <div className="flex flex-col text-cloud">
      <h2 className="font-header font-medium leading-[42px]">Membership</h2>
      <hr className="mb-12 mt-8"></hr>
      {!membership ? (
        <p>You are not currently a member</p>
      ) : (
        <div className="flex flex-col lg:justify-start lg:items-start lg:grid lg:grid-cols-3">
          <SubscriptionPlan
            id={membership.cleanId}
            plan={membership.billingPolicyInterval}
            cost={membership.orderAmount}
            interval={membership.billingPolicyInterval}
            expirationDate={membership.endsAt}
            nextBillingDate={membership.nextBillingDate}
            status={membership.status}
            customerInfo={customerInfo}
          />
          <div className="col-span-1"></div>
          <SubscriptionDetails
            id={membership.cleanId}
            nextBill={membership.nextBillingDate}
            payment={membership.paymentMethod}
          />
        </div>
      )}
      <div className="mt-4">
        <h4 className="font-header italic leading-8 font-normal mt-14 md:text-center lg:text-left">
          Invoices
        </h4>
        <div className="lg:grid hidden lg:grid-cols-5 gap-2 mt-6">
          <p className="font-normal text-lg">Date</p>
          <p className="font-normal text-lg">Invoice Number</p>
          <p className="font-normal text-lg">Subscription</p>
          <p className="font-normal text-lg">Amount</p>
        </div>
        <hr className="mt-3 mb-5 hidden lg:block"></hr>
        {membershipOrders.length > 0 ? (
          membershipOrders.map((order) => (
            <InvoiceCard key={order.id} invoice={order} />
          ))
        ) : (
          <p>No invoices to show</p>
        )}
      </div>
    </div>
  );
};

export default MembershipTab;
